export interface RAFProps {
  user_name?: string;
  full_name?: string;
  mail?: string;
  assignated_roles?: number[];
}

export const getRAFilterRequest = (event: RAFProps) => {
  return {
    ...(event?.mail
      ? {
          Mail: event?.mail,
        }
      : {}),
    ...(event?.full_name
      ? {
          NombreApellido: event?.full_name,
        }
      : {}),

    ...(event?.assignated_roles?.length
      ? {
          Roles: event?.assignated_roles,
        }
      : {}),
  };
};
